import { render, staticRenderFns } from "./StartseiteBanner.vue?vue&type=template&id=c61fba2a&scoped=true&"
import script from "./StartseiteBanner.vue?vue&type=script&lang=js&"
export * from "./StartseiteBanner.vue?vue&type=script&lang=js&"
import style0 from "./StartseiteBanner.vue?vue&type=style&index=0&id=c61fba2a&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c61fba2a",
  null
  
)

export default component.exports